import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import { toJS } from 'mobx';
import { Form, Row, Col, Button, Input, DatePicker, Select, Tooltip } from 'antd';
import constant from './constant';

const { platArr } = constant;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const FormItem = Form.Item;
const createForm = Form.create;
@inject('ecodeDemoStore')
@observer
class App extends React.Component {
  static defaultProps = {
		prefixCls: 'sys-user',
  }
  componentDidMount() {
    const { ecodeDemoStore: { getTypeArr } } = this.props;
    getTypeArr();
  }
  onSearch = () => {
    const { getParams, ecodeDemoStore: { getLogList, getDeletedDemo, searchTagId, setMobxState, getEcodeLogList, activitykey, customerDownloadLog,getMemberList, searchFormValue, getAppManage }, form } = this.props;
    const params = {...form.getFieldsValue(), ...toJS(searchFormValue)};
    const param = getParams(params);
    setMobxState({ pageNum: 1 });
    if (activitykey == "downloadlog") {
      if (param.startDate) {
        param.startDate = param.startDate.format('YYYY-MM-DD');
        param.endDate = param.endDate.format('YYYY-MM-DD');
      }
      // delete param.title;
      delete param.tagId;
      delete param.description;
      delete param.platform;
      delete param.userName;
      getEcodeLogList(param);
    } else if (activitykey == "demorenew") {
      delete param.tagId;
      getDeletedDemo(param);
    } else if(activitykey == 'cusdownloadlog'){
        if (param.startDate){
            param.startDate = param.startDate.format('YYYY-MM-DD');
            param.endDate = param.endDate.format('YYYY-MM-DD');
        }
        delete param.tagId;
        delete param.platform;
        delete param.demotype;
        customerDownloadLog(param);
    } else if(activitykey == 'memberlist') {
        getMemberList(params);
    } else if (activitykey == 'appmanage') {
      getAppManage(param);
    } else {
      delete param.username;
      delete param.usermobile;
      delete param.ecodeversion;
      delete param.ecversion;
      // param.tagId = searchTagId.join(',');
      getLogList(param);
    }
  }
  onReset = () => {
    const { form, ecodeDemoStore: { setMobxState, getDeletedDemo, getLogList, getEcodeLogList, activitykey, customerDownloadLog, getEcodeRole, getMemberList, getAppManage } } = this.props;
    form.resetFields();
    setMobxState({ searchFormValue: {} });
    if (activitykey == "downloadlog") {
      getEcodeLogList();
    } else if (activitykey == "demorenew") {
      getDeletedDemo();
    } else if(activitykey == 'cusdownloadlog'){
        customerDownloadLog();
    } else if(activitykey == 'ecoderole'){
        getEcodeRole();
    } else if(activitykey == 'memberlist') {
      getMemberList();
    } else if (activitykey === 'appmanage') {
      getAppManage();
    } else {
      getLogList({ approval: activitykey });
    }
  }

  getMemberSearch = (wrapCls, formItemLayout) => {
      const { prefixCls, formPrefixCls, form, ecodeDemoStore: { searchFormValue } } = this.props;
      const { getFieldProps } = form;
      const searchValues = toJS(searchFormValue);
      return (
          <div className={wrapCls}>
              <Form>
                  <Row>
                      <Col span={8} className={`${formPrefixCls}-row`}>
                          <FormItem label="用户名：" {...formItemLayout}>
                              <Input {...getFieldProps('name', {
                                  initialValue: searchValues.username || '',
                              })} placeholder="请输入用户名"
                              onBlur={this.onSearch} />
                          </FormItem>
                      </Col>
                      <Col span={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn`}>
                          <Button type="primary" onClick={this.onSearch}>搜索</Button>
                          <Button onClick={this.onReset}>重置</Button>
                      </Col>
                  </Row>
              </Form>
          </div>
      )
  }
  getDownLoadLogSearch = (wrapCls, formItemLayout) => {
    const { prefixCls, formPrefixCls, form, ecodeDemoStore: { searchFormValue } } = this.props;
    const { getFieldProps } = form;
    const searchValues = toJS(searchFormValue);
    return (
      <div className={wrapCls}>
        <Form>
          <Row>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="案例名称：" {...formItemLayout}>
                <Input  {...getFieldProps('title', {
                  initialValue: searchValues.title || '',
                  })} placeholder="请输入案例名称"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="用户名：" {...formItemLayout}>
                <Input {...getFieldProps('username', {
                  initialValue: searchValues.username || '',
                  })} placeholder="请输入用户名"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="公司：" {...formItemLayout}>
                <Input  {...getFieldProps('company', {
                  initialValue: searchValues.company || '',
                  })} placeholder="请输入公司"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="登录ID：" {...formItemLayout}>
                <Input  {...getFieldProps('usermobile', {
                  initialValue: searchValues.usermobile || '',
                  })} placeholder="请输入登录ID"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="下载时间：" {...formItemLayout}>
                <RangePicker 
                // {...getFieldProps('subDate', {
                //   initialValue: searchValues.subDate || [],
                //   })}
                  value={searchValues.subDate || []}
                  format="YYYY-MM-DD"
                  onChange={(value) => this.handleSelectChange('subDate', value)}/>
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="ecology版本：" {...formItemLayout}>
                <Input  {...getFieldProps('ecversion', {
                  initialValue: searchValues.ecversion || '',
                  })} placeholder="请输入ecology版本"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="ecode版本：" {...formItemLayout}>
                <Input  {...getFieldProps('ecodeversion', {
                  initialValue: searchValues.ecodeversion || '',
                  })} placeholder="请输入ecode版本"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
            <Col span={8} offset={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn sys-ecode-row-btn`}>
              <Row className="ant-form-item">
                <Col className="ant-form-item-label" sm={formItemLayout.labelCol.sm.span} xs={formItemLayout.labelCol.xs.span}></Col>
                <Col sm={formItemLayout.wrapperCol.sm.span} xs={formItemLayout.wrapperCol.xs.span}>
                  <Button type="primary" onClick={this.onSearch}>搜索</Button>
                  <Button onClick={this.onReset}>重置</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
  getCusDownLoadLog = (wrapCls, formItemLayout) => {
    const { prefixCls, formPrefixCls, form, ecodeDemoStore: { searchFormValue } } = this.props;
    const { getFieldProps } = form;
    const searchValues = toJS(searchFormValue);
    return (
      <div className={wrapCls}>
        <Form>
          <Row>
            <Col span={16} className={`${formPrefixCls}-row`}>
              <FormItem label="案例名：" {...formItemLayout}>
                <Input {...getFieldProps('title', {
                  initialValue: searchValues.title || '',
                  })} placeholder="请输入案例名"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="账号：" {...formItemLayout}>
                <Input  {...getFieldProps('account', {
                  initialValue: searchValues.account || '',
                })} placeholder="请输入账号"
                onBlur={this.onSearch} />
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="下载时间：" {...formItemLayout}>
                <RangePicker
                //  {...getFieldProps('subDate', {
                //   initialValue: searchValues.subDate || [],
                //   })}
                  value={searchValues.subDate || []}
                  format="YYYY-MM-DD"
                  onChange={(value) => this.handleSelectChange('subDate', value)}/>
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn sys-ecode-row-btn`}>
              <Row className="ant-form-item">
                <Col className="ant-form-item-label" sm={formItemLayout.labelCol.sm.span} xs={formItemLayout.labelCol.xs.span}></Col>
                <Col sm={formItemLayout.wrapperCol.sm.span} xs={formItemLayout.wrapperCol.xs.span}>
                  <Button type="primary" onClick={this.onSearch}>搜索</Button>
                  <Button onClick={this.onReset}>重置</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
  getAppManageSearch = (wrapCls, formItemLayout) => {
    const { prefixCls, formPrefixCls, form, ecodeDemoStore: { searchFormValue } } = this.props;
    const { getFieldProps } = form;
    const searchValues = toJS(searchFormValue);
    return (
      <div className={wrapCls}>
        <Form>
          <Row>
            <Col span={16} className={`${formPrefixCls}-row`}>
              <FormItem label="案例名：" {...formItemLayout}>
                <Input {...getFieldProps('title', {
                  initialValue: searchValues.title || '',
                  })} placeholder="请输入案例名"
                  onBlur={this.onSearch} />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="案例类型：" {...formItemLayout}>
                <Select
                  onChange={(value) => this.handleSelectChange('caseType', value)}
                  value={searchValues.caseType || []}
                >
                  <Option style={{ height: '32px' }} label="" key="" value=""></Option>
                  <Option style={{ height: '32px' }} label="应用类" key="app" value="app">应用类</Option>
                  <Option style={{ height: '32px' }} label="案例类" key="case" value="case">案例类</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
              <FormItem label="是否总部开发：" {...formItemLayout}>
                <Select
                  onChange={(value) => this.handleSelectChange('headquarters', value)}
                  value={searchValues.headquarters || []}
                >
                  <Option style={{ height: '32px' }} label="" key="" value=""></Option>
                  <Option style={{ height: '32px' }} label="非总部" key="y" value="y">总部</Option>
                  <Option style={{ height: '32px' }} label="总部" key="n" value="n">非总部</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn sys-ecode-row-btn`}>
              <Row className="ant-form-item">
                <Col className="ant-form-item-label" sm={formItemLayout.labelCol.sm.span} xs={formItemLayout.labelCol.xs.span}></Col>
                <Col sm={formItemLayout.wrapperCol.sm.span} xs={formItemLayout.wrapperCol.xs.span}>
                  <Button type="primary" onClick={this.onSearch}>搜索</Button>
                  <Button onClick={this.onReset}>重置</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
  handleSelectChange = (key, value) => {
    const { onChange, ecodeDemoStore: { searchFormValue } } = this.props;
    typeof onChange === 'function' && onChange({ 
      ...toJS(searchFormValue),
      [`${key}`]: value,
    });
    this.onSearch();
  }
  render() {
    const {
			prefixCls,
			formPrefixCls,
			form,
			ecodeDemoStore: {
				allTag, activitykey, searchFormValue,
			},
    } = this.props;
    let { ecodeDemoStore: { typeArr } } = this.props;
    typeArr = toJS(typeArr);
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
		const wrapCls = classNames({
			[`${prefixCls}-header`]: true,
			'sys-ecode-search': true,
		})
    const { getFieldProps } = form;
    const searchValues = toJS(searchFormValue);
    if (Object.keys(searchValues).length === 0) {
      form.resetFields();
    }
    if (activitykey === 'downloadlog') return this.getDownLoadLogSearch(wrapCls, formItemLayout);
    if (activitykey === 'cusdownloadlog') return this.getCusDownLoadLog(wrapCls, formItemLayout);
    if (activitykey === 'tagmanage' || activitykey === 'demorenew') return null;
    if (activitykey === 'ecoderole') return null;
    if (activitykey === 'memberlist') return this.getMemberSearch(wrapCls, formItemLayout);
    if (activitykey === 'appmanage') return this.getAppManageSearch(wrapCls, formItemLayout);
    return (
			<div className={wrapCls}>
				<Form>
					<Row>
						<Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="案例名称：" {...formItemLayout}>
								<Input {...getFieldProps('title', {
                  initialValue: searchValues.title || '',
                })} placeholder="请输入案例名"
                onBlur={this.onSearch} />
							</FormItem>
						</Col>
						<Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="详细描述：" {...formItemLayout}>
								<Input  {...getFieldProps('description', {
                  initialValue: searchValues.description || '',
                })} placeholder="请输入案例描述" onBlur={this.onSearch} />
							</FormItem>
						</Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="上传时间：" {...formItemLayout}>
                <RangePicker
                // {...getFieldProps('subDate', {
                //   initialValue: searchValues.subDate || [],
                // })}
                  format="YYYY-MM-DD"
                  value={searchValues.subDate || []}
                  onChange={(value) => this.handleSelectChange('subDate', value)} />
							</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="上传者姓名：" {...formItemLayout}>
								<Input  {...getFieldProps('userName', {
                    initialValue: searchValues.userName || '',
                  })} placeholder="请输入上传者姓名" onBlur={this.onSearch} />
							</FormItem>
						</Col>
						<Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="公司名称：" {...formItemLayout}>
								<Input  {...getFieldProps('company', {
                    initialValue: searchValues.company || '',
                  })} placeholder="请输入公司名称" onBlur={this.onSearch} />
							</FormItem>
						</Col>
            <Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="平台：" {...formItemLayout}>
								<Select
                  placeholder="请选择平台"
                  optionLabelProp="label"
                  onBlur={this.onSearch}
                  onChange={(value) => this.handleSelectChange('platform', value)}
                 // onChange={this.handleSelectChange}
                  // {...getFieldProps('platform', {
                  //   initialValue: searchValues.platform || [],
                  // })}
                  value={searchValues.platform || []}
                >
                  {
                    platArr.map(item => {
                      return (<Option style={{ height: '32px' }} label={item.name} key={item.id} value={item.id}>{item.name}</Option>)
                    })
                  }
                </Select>
							</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="标签：" {...formItemLayout}>
								<Select
                  placeholder="请选择标签"
									mode="multiple"
									notFoundContent="无匹配结果"
                  optionLabelProp="label"
                  onBlur={this.onSearch}
                  // onChange={this.handleSelectChange}
                  {...getFieldProps('tagId', {
                    initialValue: searchValues.tagId || [],
                  })}
                  >
                  {
                    allTag && allTag.map(item => {
                      return (<Option label={item.typeName} key={item.id} value={item.id}>{item.typeName}</Option>)
                    })
                  }
                </Select>
							</FormItem>
						</Col>
						<Col span={8} className={`${formPrefixCls}-row`}>
							<FormItem label="类别：" {...formItemLayout}>
								<Select
									placeholder="请选择类别"
                  optionLabelProp="label"
                  onChange={(value) => this.handleSelectChange('demotype', value)}
                  // {...getFieldProps('demotype', {
                  //   initialValue: searchValues.demotype || [],
                  // })}
                  value={searchValues.demotype || []}
                >
                  {
                    typeArr.map(item => {
                      return (<Option style={{ height: '32px' }} label={item.desc || item.name} key={item.demotype || item.id} value={item.demotype || item.id}>
                        <Tooltip placement="right" title={item.info || item.desc || item.name}>
                          <div>{item.desc || item.name}</div>
                        </Tooltip>
                      </Option>)
                    })
                  }
                </Select>
							</FormItem>
						</Col>
            <Col span={8} className={`${formPrefixCls}-row ${prefixCls}-row-btn sys-ecode-row-btn`}>
              <Row className="ant-form-item">
                <Col className="ant-form-item-label" sm={formItemLayout.labelCol.sm.span} xs={formItemLayout.labelCol.xs.span}></Col>
                <Col sm={formItemLayout.wrapperCol.sm.span} xs={formItemLayout.wrapperCol.xs.span}>
                  <Button type="primary" onClick={this.onSearch}>搜索</Button>
                  <Button onClick={this.onReset}>重置</Button>
                </Col>
              </Row>
						</Col>
					</Row>
				</Form>
			</div>
    )
  }
}

App = createForm({
  onValuesChange(props, changedValues, allValues) {
    props.onChange(allValues);
  },
})(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/Search.js